import { Injectable } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';
import * as moment from 'moment-timezone';

@Injectable()
export class BudgetingService {

    constructor() { }

    public getCurrencySymbol(currency: string) {
        return getCurrencySymbol(currency, 'wide');
    }

    public getCurrencyAbbrevWithSymbol(currency: string) {
        return currency + '(' + getCurrencySymbol(currency, 'wide') + ')';
    }

    // browser default to local time, this will use the same day but changing the timezone offset
    public convertToLocalTime(value: any, marketTimeZone: string, field: 'startDate' | 'endDate'): Date {
        let m = moment(value).tz(marketTimeZone, true);
        if (field == 'startDate') {
            return m.startOf("day").toDate();
        } else {
            return m.endOf("day").milliseconds(0).toDate();
        }
    }

    // local time to browser default, this will use the same day but changing the timezone offset
    public convertFromLocalTime(value: any, marketTimeZone: string, field: 'startDate' | 'endDate'): Date {
        let m = moment(value).tz(marketTimeZone).local(true);
        if (field == 'startDate') {
            return m.startOf("day").toDate();
        } else {
            return m.endOf("day").milliseconds(0).toDate();
        }
    }

}